module.exports = __webpack_public_path__ + "1703f4cfb29bcc79ad162bb5d89e583f.png";